// EN
export const reservasSmallHc = {
  createAlerta: {
    title: "Neue Erinnerung erstellen",
    infoHeading: "Angaben zur Erinnerung",
    selectPropertyLabel: "Wählen Sie die Unterkunft, der Sie die Erinnerung zuordnen möchten",
    dayLabel: "Wählen Sie einen Wochentag:",
    dayMonday: "Montag",
    dayTuesday: "Dienstag",
    dayWednesday: "Mittwoch",
    dayThursday: "Donnerstag",
    dayFriday: "Freitag",
    daySaturday: "Samstag",
    daySunday: "Sonntag",
    selectTimeLabel: "Uhrzeit auswählen",
    sendAtLabel: "Wird gesendet um:",
    minutesLabel: "Mit {minutes} Minuten:",
    previewPre: "Der Hinweis wird an die Gäste gesendet am",
    previewMid: "um",
    descriptionLabel: "Beschreibung des Hinweises",
    descriptionPlaceholder: "Geben Sie eine Beschreibung für den Hinweis ein",
    messageTypeLabel: "Wählen Sie die Art der Nachricht, die gesendet werden soll.",
    messageTypeSimple: "Einfache Nachricht",
    messageTypeLink: "Nachricht mit einem Link am Ende",
    messageTypeFile: "Nachricht mit einer angehängten Datei am Ende",
    linkFieldLabel: "Geben Sie den Link ein, der mit der Erinnerung gesendet wird",
    fileFieldLabel: "Laden Sie die Datei hoch, die mit der Erinnerung gesendet wird",
    fileNameLabel: "Dateiname",
    cancel: "Abbrechen",
    save: "Erinnerung speichern",
    errorDayRequired: "Der Tag ist erforderlich",
    errorTimeRequired: "Die Uhrzeit ist erforderlich",
    errorSelectMinutes: "Wählen Sie die Minuten aus",
    errorDescriptionRequired: "Die Beschreibung ist erforderlich",
    errorAttachmentRequired: "Der Anhang ist erforderlich, oder stellen Sie den Nachrichtentyp auf einfach",
  },
  reservationData: {
    statusConfirmed: "Bestätigt",
    statusRejected: "Abgelehnt",
    statusTentative: "Nach Verfügbarkeit",
    statusWithinCheckin: "Innerhalb der Check-in-Zeiten",
    statusFree: "Ohne Aufpreis",
    modalTitleApprove: "Anfrage genehmigen?",
    modalTitleApproveTime: "Zu einer anderen Uhrzeit genehmigen?",
    modalTitlePrioritize: "Diesen Check-in bevorzugt behandeln?",
    modalTitleReject: "Anfrage ablehnen?",
    modalTitleDefault: "Bestätigen?",
    modalTextApprove: "Sie genehmigen den frühen Check-in für",
    modalTextApproveTime: "Sie bestätigen den Check-in zu der von Ihnen angegebenen Uhrzeit für",
    modalTextPrioritize: "Wir sagen dem Gast, dass Sie alles tun, damit es bis dahin bereit ist, es aber vom vorherigen Check-out und der Reinigung abhängt. Gesendet an",
    modalTextReject: "Sie lehnen den frühen Check-in ab für",
    modalTextDefault: "Bestätigen für",
    modalCtaApprove: "Ja, genehmigen",
    modalCtaApproveTime: "Uhrzeit bestätigen",
    modalCtaPrioritize: "Ja, mitteilen",
    modalCtaReject: "Ja, ablehnen",
    modalCtaDefault: "Bestätigen",
    kpiRoom: "Zimmer",
    kpiLodging: "Unterkunft",
    guestsCount: "Gast | Gäste",
    adultsCount: "Erwachsener | Erwachsene",
    childrenCount: "Kind | Kinder",
    infantsCount: "Kleinkind | Kleinkinder",
    roomsCountValue: "{count} Zimmer",
    holderRole: "Buchungsinhaber",
    noEmail: "Keine E-Mail hinterlegt",
    writeWhatsapp: "Auf WhatsApp schreiben",
    noPhoneTitle: "Ohne Telefonnummer ist der Versand über WhatsApp nicht möglich. Sie können sie unter «Buchung bearbeiten» ergänzen.",
    noPhone: "Keine Telefonnummer hinterlegt",
    kpiCheckin: "Check-in",
    kpiCheckout: "Check-out",
    earlyRequested: "Früher Check-in angefragt",
    arrivalRequested: "Ankunftszeit angefragt",
    arrivesAt: "Ankunft um {time}",
    actionApprove: "Genehmigen",
    actionOtherTime: "Andere Uhrzeit",
    actionPrioritize: "Bevorzugen",
    actionReject: "Ablehnen",
    awaitingPayment: "Warten auf die Zahlung des Gastes",
    cannotUndo: "Diese Aktion kann nicht rückgängig gemacht werden.",
    checkinTimeLabel: "Uhrzeit des Check-ins",
    earlyPrioritisedTitle: "Früher Check-in priorisiert",
    earlyApprovedTitle: "Früher Check-in bestätigt",
    earlyRejectedTitle: "Früher Check-in abgelehnt",
    earlyLineApproved: "Kommt um {time} an",
    earlyLineApprovedOther: "Kommt um {time} an · hatte {original} angefragt",
    earlyLineRejected: "Hatte {time} angefragt · checkt zur üblichen Zeit ein",
    earlyLineRejectedStd: "Hatte {time} angefragt · checkt zur üblichen Zeit ein ({std})",
    earlyLinePrioritised: "Möchte um {time} ankommen · wir tun unser Bestes",
    extRequestedTitle: "Aufenthaltsverlängerung angefragt",
    extAwaitingTitle: "Aufenthaltsverlängerung wartet auf Zahlung",
    extConfirmedTitle: "Aufenthaltsverlängerung bestätigt",
    extNights: "Hinzugefügte Nächte: {nights} · neue Abreise am {date}",
    extAtProperty: "{amount} vor Ort zu zahlen",
    extPendingHost: "wartet auf Ihre Freigabe",
    lateRequestedTitle: "Später Check-out angefragt",
    lateAwaitingTitle: "Später Check-out – Zahlung ausstehend",
    lateConfirmedTitle: "Später Check-out bestätigt",
    lateRejectedTitle: "Später Check-out abgelehnt",
    lateLeavesAt: "Reist um {time} ab",
    lateWantsToLeave: "Möchte um {time} abreisen",
    lateInsteadOf: "(statt um {std})",
    latePaid: "Bezahlt: {amount}",
    lateCourtesy: "Kulanzstunde, kostenlos",
    lateFree: "Kostenlos",
    lateCash: "{amount} in bar bei der Abreise",
    lateUnpaid: "{amount}, noch nicht bezahlt",
    lateLineRejected: "Wollte um {time} abreisen · reist zur üblichen Zeit ab",
    lateLineRejectedStd: "Wollte um {time} abreisen · reist zur üblichen Zeit ab ({std})",
    requestedTimeHint: "Der Gast hat {time} angefragt",
    toastApproved: "Früher Check-in bestätigt",
    toastApprovedTime: "Neue Check-in-Zeit bestätigt",
    toastPrioritised: "Früher Check-in priorisiert",
    toastRejected: "Früher Check-in abgelehnt",
    toastNotified: "Der Gast wurde bereits benachrichtigt.",
    toastNotNotified: "Der Gast konnte nicht benachrichtigt werden: Bitte schreiben Sie ihm selbst.",
    toastAlreadyDecided: "Diese Anfrage war bereits entschieden: Der Gast wurde nicht erneut benachrichtigt.",
    toastError: "Die Entscheidung konnte nicht gespeichert werden. Bitte erneut versuchen.",
    toastAlreadyPaid: "Er war bereits bezahlt: Es wurde nicht erneut berechnet.",
    toastRefundMaybeDue: "Der Gast hat für einen früheren Check-in bezahlt und kommt jetzt zur üblichen Zeit: ggf. erstatten.",
    actionReadyNow: "Kann jetzt einchecken",
    actionNotPossible: "Wird nicht möglich sein",
    toastPaymentLinkFailed: "Der Zahlungslink konnte nicht erstellt werden: bitte anders kassieren.",
    arrivalApprovedTitle: "Ankunftszeit bestätigt",
    arrivalRejectedTitle: "Ankunftszeit abgelehnt",
    arrivalLineRejected: "Wollte um {time} ankommen",
    modalTextApproveArrival: "Sie bestätigen die Ankunftszeit von",
    modalTextRejectArrival: "Sie lehnen die Ankunftszeit ab von",
    toastArrivalApproved: "Ankunftszeit bestätigt",
    toastArrivalRejected: "Ankunftszeit abgelehnt",
    cancel: "Abbrechen",
  },
  minStayModal: {
    summaryNoData: "Keine Daten im ausgewählten Zeitraum",
    summaryHintMixed: "Im Zeitraum wurden mehrere Mindestaufenthalte erkannt. Das Feld steht auf 1 Nacht, damit Sie den neuen Wert festlegen können.",
    summaryHintSingle: "Das Feld wurde mit dem aktuellen Mindestaufenthalt des ausgewählten Zeitraums gefüllt.",
    errorMinOne: "Der Mindestaufenthalt muss mindestens 1 Nacht betragen.",
    opStartLabel: "Mindestaufenthalt wird geändert…",
    successUpdated: "Mindestaufenthalt erfolgreich aktualisiert",
    errorUpdate: "Fehler beim Aktualisieren des Mindestaufenthalts",
    errorUnknown: "Unbekannter Fehler",
    title: "Mindestaufenthalt",
    description: "Legen Sie den Mindestaufenthalt in Nächten für den ausgewählten Zeitraum fest.",
    detectedLabel: "Erkannte Mindestaufenthalte",
    minStayLabel: "Mindestaufenthalt (Nächte)",
    decreaseAria: "Mindestaufenthalt verringern",
    minNightsPlaceholder: "z. B. 2",
    increaseAria: "Mindestaufenthalt erhöhen",
    hint: "Mindestanzahl an Nächten, die der Gast buchen muss.",
    cancel: "Abbrechen",
    save: "Speichern",
  },
  modalCompleteReservation: {
    errorContactRequired: "Um fortzufahren, müssen Sie eines der beiden Felder ausfüllen (Telefon oder E-Mail)",
    successMsg: "Buchungsdaten erfolgreich vervollständigt",
    successTitle: "Vorgang erfolgreich abgeschlossen",
    title: "Buchung vervollständigen",
    bookingDateLabel: "Buchungsdaten",
    checkin: "Check-in",
    checkout: "Check-out",
    phoneRequiredHint: "* Einziges Pflichtfeld",
    emailHint: "*Wenn Sie die E-Mail angeben, muss der Gast sie nicht eingeben",
    responsibleLabel: "Geben Sie den Namen der verantwortlichen Person ein",
    responsiblePlaceholder: "Für die Buchung verantwortliche Person",
    scheduleLabel: "Legen Sie fest, wann der Check-in-Link gesendet wird.",
    scheduleAuto: "Automatischer Versand",
    schedule24: "24 Stunden vor dem Check-in",
    schedule48: "48 Stunden vor dem Check-in",
    schedule72: "72 Stunden vor dem Check-in",
    scheduleWeek: "Eine Woche vor dem Check-in",
    cancel: "Abbrechen",
    complete: "Buchung vervollständigen",
  },
  payData: {
    errorNoPaymentRecord: "Der Zahlungseintrag konnte nicht ermittelt werden.",
    partialLinkGenerated: "Zahlungslink erfolgreich erstellt.",
    errorGenerateLink: "Der Link konnte nicht erstellt werden.",
    partialRegistered: "Teilzahlung erfasst.",
    errorSavePartial: "Die Teilzahlung konnte nicht gespeichert werden.",
    whatsappPartialMsg: "Hallo {name}, hier ist der Link, um den offenen Betrag Ihrer Buchung zu begleichen: {url}",
    errorInvoicingNotActive: "Die elektronische Rechnung ist in Ihrem Plan nicht aktiviert.",
    fieldBillingProfile: "Rechnungsprofil",
    fieldCountry: "Land",
    fieldLegalName: "Firmenname",
    fieldTaxId: "NIF/CIF/NIT",
    fieldAddressStreet: "Adresse",
    fieldAddressCity: "Stadt",
    fieldAddressRegion: "Region",
    fieldAddressZip: "Postleitzahl",
    fieldEmail: "E-Mail",
    fieldIsActive: "Profil aktivieren",
    errorBillingIncomplete: "Vervollständigen Sie Ihre Rechnungsdaten. Es fehlen: {fields}",
    invoiceLinkCopied: "Rechnungslink kopiert.",
    reservationHasInvoice: "Für diese Buchung liegt bereits eine Rechnung vor.",
    errorLoadReceipt: "Der Beleg konnte nicht geladen werden.",
    errorDownloadReceipt: "Der Beleg konnte nicht heruntergeladen werden.",
    guestOutOfWindow: "Der Gast ist außerhalb des 24-Stunden-Fensters von WhatsApp.",
    errorSendReceipt: "Fehler beim Senden des Belegs.",
    charge: "Betrag",
    lodging: "Unterkunft",
    servicesExtras: "Leistungen und Extras",
    free: "Kostenlos",
    ivaIncluded: "(inkl. {rate} % MwSt.)",
    includedInPrice: "(im Preis enthalten)",
    pendingCharge: "Zahlung ausstehend",
    viewBreakdown: "Preisaufstellung ansehen",
    viewReceipt: "Beleg ansehen",
    receiptInfoPre: "Informationsbeleg. Die elektronische Rechnung wird erstellt im Reiter",
    chargesTab: "Positionen",
    receiptInfoNoInvoice: "Informationsbeleg verfügbar. Für die elektronische Rechnung hinterlegen Sie Ihre Rechnungsdaten.",
    reservationNumber: "Buchung #{code}",
    currentStatus: "Aktueller Status",
    willChangeTo: "Wird geändert zu:",
    saving: "Wird gespeichert…",
    breakdownTitle: "Preisaufstellung",
    discounts: "Rabatte",
    taxesAndFees: "Steuern und Gebühren",
    ivaIncludedInPrice: "MwSt. ({rate} %) im Preis enthalten: {amount}",
    includesTaxes: "Enthält {amount} an im Preis enthaltenen Steuern",
    total: "Summe",
    close: "Schließen",
    loadingReceipt: "Beleg wird geladen…",
    stayReceipt: "Beleg des Aufenthalts · {date}",
    downloadPdf: "PDF herunterladen",
    sending: "Wird gesendet…",
    sent: "Gesendet!",
    outOfWindow: "Außerhalb des 24-Stunden-Fensters",
    sendWhatsapp: "Per WhatsApp senden",
    stayDetail: "Details des Aufenthalts",
    ivaIncludedShort: "inkl. {rate} % MwSt.",
    discount: "Rabatt",
    nightsCount: "Nacht | Nächte",
    additionalCharges: "Zusätzliche Gebühren",
    ivaShort: "MwSt. {rate} %",
    charged: "Kassiert",
    pending: "Ausstehend",
    receiptGeneratedBy: "Beleg erstellt von",
    done: "Fertig",
    registerPartial: "Teilzahlung erfassen",
    reservationTotal: "Buchungssumme",
    amountReceived: "Bereits erhaltener Betrag",
    paid: "Bezahlt",
    pendingBalance: "Offener Restbetrag",
    amountExceedsTotal: "Der erhaltene Betrag übersteigt die Summe. Verwenden Sie den Status",
    paidStatus: "Bezahlt",
    internalNote: "Interne Notiz",
    optional: "(optional)",
    notePlaceholder: "z. B. Erste Zahlung per Überweisung erhalten...",
    autoLinkNote: "Beim Speichern wird der Zahlungslink automatisch aktualisiert auf",
    cancel: "Abbrechen",
    savePartial: "Teilzahlung speichern",
    roomsCount: "{count} Zimmer | {count} Zimmer",
    groupNotePre: "Betrag für die",
    groupNoteCombined: "kombinierte Buchung",
    groupNoteMid: "Aufstellung nach Zimmer weiter unten.",
  },
};
